var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('strong',[_vm._v(_vm._s(_vm.title))])]),_c('div',[_c('i',[_vm._v(_vm._s(_vm.created_on))])]),_c('div',[_vm._v("link "+_vm._s(_vm.urlId))])])}
var staticRenderFns = []

export { render, staticRenderFns }